module.exports = __webpack_public_path__ + "media/images/pc/page_common/banner/banner_costumes@2x-9253b46fc887b63b8c4e345647055bd2.webp";